module.exports = __webpack_public_path__ + "images/check-af35f846.svg";